import { render, staticRenderFns } from "./b-radio.vue?vue&type=template&id=5c92636b&"
import script from "./b-radio.vue?vue&type=script&lang=js&"
export * from "./b-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports